import { ReactNode } from 'react';
import cls from 'classnames';

import useStyles from './headerStyles';

function SliderHeader({ text }: { text: ReactNode | string }) {
  const classes = useStyles();

  return <h2 className={cls(classes.root, 'fs-20')}>{text}</h2>;
}

export default SliderHeader;
